var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_259_1455)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.125,
    y: 10.8125,
    width: 52.875,
    height: 52.875,
    rx: 26.4375,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0625 41C40.7335 41 42.0625 39.669 42.0625 38C42.0625 36.331 40.7335 35 39.0625 35C37.3915 35 36.0625 36.331 36.0625 38C36.0625 39.669 37.3915 41 39.0625 41Z",
    fill: "#ED4D41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8795 36.186C47.6439 35.0344 47.1834 33.9405 46.5245 32.967C45.8771 32.0093 45.0522 31.1844 44.0945 30.537C43.1209 29.8783 42.0271 29.4179 40.8755 29.182C40.2706 29.0593 39.6547 28.999 39.0375 29.002V27L35.0625 30L39.0375 33V31.002C39.5215 31 40.0055 31.046 40.4725 31.142C41.3675 31.3254 42.2177 31.6832 42.9745 32.195C43.7209 32.6982 44.3633 33.3406 44.8665 34.087C45.6478 35.2422 46.0645 36.6054 46.0625 38C46.0623 38.9359 45.8753 39.8623 45.5125 40.725C45.336 41.1405 45.1204 41.5383 44.8685 41.913C44.6156 42.2854 44.3284 42.6332 44.0105 42.952C43.0425 43.9182 41.8136 44.5809 40.4745 44.859C39.5432 45.047 38.5838 45.047 37.6525 44.859C36.7571 44.6754 35.9065 44.3173 35.1495 43.805C34.404 43.3022 33.7623 42.6605 33.2595 41.915C32.4791 40.7585 32.0622 39.3952 32.0625 38H30.0625C30.0636 39.7937 30.5994 41.5463 31.6015 43.034C32.2493 43.9901 33.0734 44.8142 34.0295 45.462C35.5151 46.4675 37.2686 47.0033 39.0625 47C39.6718 46.9999 40.2795 46.9386 40.8765 46.817C42.0272 46.5794 43.1204 46.1191 44.0945 45.462C44.5728 45.1397 45.0185 44.7717 45.4255 44.363C45.833 43.9544 46.2013 43.5084 46.5255 43.031C47.5301 41.5458 48.0656 39.7931 48.0625 38C48.0624 37.3907 48.0011 36.783 47.8795 36.186Z",
    fill: "#ED4D41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_259_1455",
    x: 0.273483,
    y: 0.442423,
    width: 76.578,
    height: 76.578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.48144
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.92576
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.166667 0 0 0 0 0.166667 0 0 0 0 0.166667 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_1455"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_1455",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.48dd608cedf63a70fc23e43dc2090444.svg";
export { ForwardRef as ReactComponent };